import React from "react";
import styled from "styled-components";
import Button from "../Button/Button";

const Root = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100% !important;
  flex-grow: 1;
  background-color: ${props => props.theme.color6};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${props => props.theme.color2};
  height: 100vh;
`;

const Buttons = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-top: 20px;
`;

const Content = styled.div`
  color: ${props => props.theme.color2};
  font-weight: 600;
  font-size: 20px;
  padding: 20px;
`;

export default ({ question, onOk, onCancel }) => {
  return (
    <Root data-id="confirmation-dialog">
      <Content>
        {question}
        <Buttons>
          <Button onClick={onCancel}>Cancel</Button>
          <Button inverted onClick={onOk}>
            OK
          </Button>
        </Buttons>
      </Content>
    </Root>
  );
};
